import React from 'react';

import { Box, makeStyles } from 'groundkeeper-component-library';

const useStyles = makeStyles(theme => ({
  emptyCell: {
    textAlign: 'center'
  }
}));

function EmptyCell(props) {
  const classes = useStyles(props);

  return <Box className={classes.emptyCell}>-</Box>;
}

EmptyCell.propTypes = {};

EmptyCell.defaultProps = {};

export default EmptyCell;
